export const no = {
  // Common
  common: {
    loading: 'Laster...',
    save: 'Lagre',
    cancel: 'Avbryt',
    delete: 'Slett',
    edit: 'Rediger',
    create: 'Opprett',
    search: 'Søk',
    filter: 'Filtrer',
    viewAll: 'Se alle',
    learnMore: 'Les mer',
    getStarted: 'Kom i gang',
    contactUs: 'Kontakt oss',
    readMore: 'Les mer',
    backTo: 'Tilbake til',
    yes: 'Ja',
    no: 'Nei',
    or: 'eller',
    and: 'og',
    theme: 'Tema',
    error: 'Feil ved lasting av data',
    tryAgain: 'Noe gikk galt. Vennligst prøv igjen.',
    retry: 'Prøv igjen',
  },

  // Navigation
  nav: {
    home: 'Hjem',
    services: {
      title: 'Tjenester',
      all: 'Alle tjenester',
      crm: 'CRM-løsninger',
      app: 'Apputvikling',
      web: 'Webutvikling',
      sms: 'SMS-markedsføring',
      voice: 'AI Stemmeagent',
    },
    caseStudies: 'Case-studier',
    blog: 'Blogg',
    about: 'Om oss',
    contact: 'Kontakt oss',
    admin: 'Admin',
    login: 'Logg inn',
    logout: 'Logg ut',
  },

  // Home page
  home: {
    seo: {
      title: 'Din partner for digital vekst',
      description: 'Din AI Bedrift hjelper norske bedrifter med CRM, apputvikling, webutvikling, SMS-markedsføring og AI-stemmeagenter.',
    },
    hero: {
      subtitle: 'B2B Digital Services',
      title: 'Digitale løsninger som',
      titleHighlight: 'driver vekst',
      description: 'Vi hjelper norske bedrifter med å lykkes digitalt. Fra CRM og apputvikling til AI-drevne løsninger - vi er din partner for digital transformasjon.',
      cta: 'Kom i gang',
      secondaryCta: 'Se våre tjenester',
      form: {
        title: 'Kom i gang i dag',
        subtitle: 'Fyll ut skjemaet, så tar vi kontakt innen 24 timer.',
        name: 'Ditt navn',
        email: 'E-postadresse',
        company: 'Bedrift (valgfritt)',
        message: 'Beskriv ditt prosjekt...',
        submit: 'Send henvendelse',
        submitting: 'Sender...',
        successTitle: 'Takk for din henvendelse!',
        successMessage: 'Vi tar kontakt med deg snart.',
      },
    },
    stats: {
      customers: 'Fornøyde kunder',
      projects: 'Prosjekter levert',
      satisfaction: 'Kundetilfredshet',
      support: 'Support',
    },
    partners: 'Partnere',
    quote: 'Vi hjelper bedrifter med å digitalisere og automatisere for å spare tid og øke inntektene.',
    intro: {
      prefix: 'Vi hjelper bedrifter med å',
      highlight1: 'digitalisere',
      middle: 'og',
      highlight2: 'automatisere',
      suffix: 'for å spare tid og øke inntektene.',
    },
    services: {
      title: 'Våre tjenester',
      subtitle: 'Komplette digitale løsninger tilpasset dine behov',
      viewAll: 'Se alle tjenester',
    },
    whyUs: {
      title: 'Hvorfor velge Din AI Bedrift?',
      description: 'Vi kombinerer norsk forretningsforståelse med internasjonal teknologiekspertise for å levere løsninger som faktisk fungerer.',
      experience: 'års erfaring',
      points: [
        'Erfarne utviklere og designere',
        'Skreddersydde løsninger for norske bedrifter',
        'Transparent kommunikasjon og prising',
        'Langsiktig partnerskap og support',
        'Moderne teknologi og beste praksis',
        'GDPR-kompatible løsninger',
      ],
      button: 'Mer om oss',
    },
    caseStudies: {
      title: 'Våre suksesshistorier',
      subtitle: 'Se hvordan vi har hjulpet andre bedrifter med å nå sine mål',
      viewAll: 'Se alle case-studier',
    },
    testimonials: {
      title: 'Hva kundene sier',
      subtitle: 'Vi er stolte av tilbakemeldingene fra våre kunder',
    },
    cta: {
      title: 'Klar for å ta neste steg?',
      description: 'La oss diskutere hvordan vi kan hjelpe din bedrift med å vokse digitalt.',
      button: 'Kontakt oss',
      secondaryButton: 'Se tjenester',
    },
  },

  // Services page
  services: {
    title: 'Våre tjenester',
    subtitle: 'Hva vi tilbyr',
    description: 'Vi leverer komplette digitale løsninger tilpasset dine behov. Fra idé til implementering, vi er med deg hele veien.',
    seoDescription: 'Utforsk våre digitale tjenester - CRM, apputvikling, webutvikling, SMS-markedsføring og AI-stemmeagenter.',
    popular: 'Populær',
    readMore: 'Les mer om',
    features: 'Funksjoner',
    featuresTitle: 'Hva inkluderer denne tjenesten?',
    benefits: 'Fordeler',
    faq: 'Ofte stilte spørsmål',
    service: 'Tjeneste',
    otherServices: 'Andre tjenester',
    viewAll: 'Se alle tjenester',
    notFound: {
      title: 'Tjeneste ikke funnet',
      description: 'Beklager, vi fant ikke tjenesten du leter etter.',
    },
    cta: {
      title: 'Usikker på hva du trenger?',
      description: 'Vi hjelper deg gjerne med å finne den riktige løsningen for din bedrift. Ta kontakt for en uforpliktende samtale.',
      button: 'Kontakt oss',
      interested: 'Interessert?',
      interestedDesc: 'Kontakt oss for en uforpliktende samtale om hvordan vi kan hjelpe deg.',
      ready: 'Klar for å komme i gang?',
      readyDesc: 'La oss diskutere hvordan',
      readyDescSuffix: 'kan hjelpe din bedrift.',
    },
  },

  // Blog page
  blog: {
    title: 'Blogg',
    subtitle: 'Innsikt og artikler',
    description: 'Hold deg oppdatert med de siste trendene innen digital transformasjon, teknologi og forretningsutvikling.',
    seoDescription: 'Les våre siste artikler om digital transformasjon, teknologi og forretningsutvikling.',
    readTime: 'min lesetid',
    categories: 'Kategorier',
    all: 'Alle',
    allPosts: 'Alle innlegg',
    noPosts: 'Ingen artikler funnet',
    noPostsCategory: 'Ingen artikler i kategorien',
    noPostsYet: 'Det er ingen publiserte artikler ennå.',
    viewAll: 'Se alle artikler',
    relatedPosts: 'Relaterte artikler',
    backToBlog: 'Tilbake til bloggen',
    tags: 'Emner',
    draft: 'Utkast',
    previous: 'Forrige',
    next: 'Neste',
    pageOf: 'Side {page} av {total}',
    notFound: {
      title: 'Artikkel ikke funnet',
      description: 'Beklager, vi fant ikke artikkelen du leter etter.',
    },
    newsletter: {
      title: 'Hold deg oppdatert',
      description: 'Få de siste artiklene og innsiktene direkte i innboksen din.',
    },
    cta: {
      title: 'Trenger du hjelp med digital transformasjon?',
      description: 'La oss diskutere hvordan vi kan hjelpe din bedrift med å vokse.',
    },
  },

  // Case Studies page
  caseStudies: {
    title: 'Case-studier',
    subtitle: 'Suksesshistorier',
    description: 'Se hvordan vi har hjulpet norske bedrifter med å oppnå sine digitale mål.',
    seoDescription: 'Utforsk våre suksesshistorier og se hvordan vi har hjulpet bedrifter med digital transformasjon.',
    client: 'Klient',
    industry: 'Bransje',
    duration: 'Varighet',
    servicesUsed: 'Tjenester brukt',
    challenge: 'Utfordringen',
    solution: 'Løsningen',
    results: 'Resultater',
    testimonial: 'Tilbakemelding',
    technologies: 'Teknologier brukt',
    gallery: 'Galleri',
    featured: 'Utvalgt',
    readMore: 'Les hele casen',
    backToCaseStudies: 'Tilbake til case-studier',
    moreCaseStudies: 'Flere case-studier',
    viewAll: 'Se alle case-studier',
    noCases: 'Ingen case-studier ennå',
    noCasesDesc: 'Vi jobber med å dokumentere våre suksesshistorier. Kom tilbake snart!',
    notFound: {
      title: 'Case-studie ikke funnet',
      description: 'Beklager, vi fant ikke case-studien du leter etter.',
    },
    cta: {
      title: 'Bli vår neste suksesshistorie',
      description: 'La oss diskutere hvordan vi kan hjelpe din bedrift med å oppnå lignende resultater.',
      button: 'Kontakt oss',
      ready: 'Klar for lignende resultater?',
      readyDesc: 'La oss diskutere hvordan vi kan hjelpe din bedrift.',
    },
  },

  // About page
  about: {
    title: 'Om oss',
    subtitle: 'Hvem vi er',
    description: 'Vi er et team av erfarne utviklere, designere og strateger som brenner for å hjelpe norske bedrifter lykkes digitalt.',
    story: {
      title: 'Vår historie',
      content: 'Din AI Bedrift ble grunnlagt med en klar visjon: å gjøre avanserte digitale løsninger tilgjengelige for norske bedrifter i alle størrelser.',
    },
    values: {
      title: 'Våre verdier',
      quality: 'Kvalitet først',
      qualityDesc: 'Vi kompromisser aldri på kvalitet.',
      partnership: 'Partnerskap',
      partnershipDesc: 'Vi ser på våre kunder som partnere.',
      innovation: 'Innovasjon',
      innovationDesc: 'Vi holder oss alltid oppdatert.',
      passion: 'Lidenskap',
      passionDesc: 'Vi brenner for det vi gjør.',
    },
    timeline: {
      title: 'Vår reise',
    },
    whyUs: {
      title: 'Hvorfor velge oss?',
      description: 'Vi kombinerer norsk forretningsforståelse med internasjonal teknologiekspertise.',
    },
  },

  // Contact page
  contact: {
    title: 'Kontakt oss',
    subtitle: 'Vi hører gjerne fra deg',
    description: 'Har du et prosjekt i tankene? Ta kontakt for en uforpliktende samtale om hvordan vi kan hjelpe deg.',
    formTitle: 'Send oss en melding',
    form: {
      name: 'Navn *',
      namePlaceholder: 'Ditt fulle navn',
      email: 'E-post *',
      emailPlaceholder: 'din@epost.no',
      phone: 'Telefon',
      phonePlaceholder: '+47 123 45 678',
      company: 'Bedrift',
      companyPlaceholder: 'Din bedrift AS',
      companySize: {
        label: 'Bedriftsstørrelse',
        placeholder: 'Velg størrelse',
        small: '1-10 ansatte',
        medium: '11-50 ansatte',
        large: '51-200 ansatte',
        enterprise: '200+ ansatte',
      },
      service: 'Hva kan vi hjelpe deg med?',
      servicePlaceholder: 'Velg tjeneste',
      other: 'Annet',
      message: 'Melding *',
      messagePlaceholder: 'Fortell oss om ditt prosjekt eller dine behov...',
      submit: 'Send melding',
      submitting: 'Sender...',
      required: '* Obligatoriske felt',
      sendNew: 'Send en ny henvendelse',
      validation: {
        nameMin: 'Navn må være minst 2 tegn',
        emailInvalid: 'Ugyldig e-postadresse',
        messageMin: 'Melding må være minst 10 tegn',
      },
    },
    success: {
      title: 'Takk for din henvendelse!',
      description: 'Vi har mottatt din melding og vil kontakte deg så snart som mulig, vanligvis innen 24 timer på hverdager.',
    },
    info: {
      title: 'Kontaktinformasjon',
      email: 'E-post',
      phone: 'Telefon',
      address: 'Adresse',
      hours: {
        title: 'Åpningstider',
        weekdays: 'Mandag - Fredag: 09:00 - 17:00',
        weekend: 'Lørdag - Søndag: Stengt',
      },
    },
  },

  // Admin
  admin: {
    common: {
      manage: 'Administrer',
      filterByStatus: 'Filtrer etter status',
      allStatuses: 'Alle statuser',
      published: 'Publisert',
      draft: 'Utkast',
      featured: 'Utvalgt',
      noDescription: 'Ingen beskrivelse',
      notPublished: 'Ikke publisert',
      readingTime: 'min lesetid',
      previous: 'Forrige',
      next: 'Neste',
      pageOf: 'Side {page} av {total}',
      confirmDelete: 'Er du sikker på at du vil slette "{name}"?',
      confirmDeleteGeneric: 'Er du sikker på at du vil slette dette?',
      cannotUndo: 'Denne handlingen kan ikke angres.',
      deleteConfirm: 'Slett',
      interestedIn: 'Interessert i',
      received: 'Mottatt',
      unpublish: 'Avpubliser',
      publish: 'Publiser',
      markFeatured: 'Marker som utvalgt',
      removeFeatured: 'Fjern fra utvalgt',
    },
    dashboard: {
      title: 'Dashbord',
      welcome: 'Velkommen tilbake',
      overview: 'Her er en oversikt over nettstedet ditt',
      recentLeads: 'Nyeste leads',
      recentPosts: 'Siste blogginnlegg',
      leadStatusOverview: 'Lead-status oversikt',
      quickActions: 'Hurtighandlinger',
      viewAll: 'Se alle',
      ofTotal: 'av {total} totalt',
      noCategory: 'Ingen kategori',
      newLeads: 'Nye leads',
      blogPosts: 'Blogginnlegg',
      services: 'Tjenester',
      caseStudies: 'Case-studier',
      newBlogPost: 'Nytt blogginnlegg',
      viewLeads: 'Se leads',
      editServices: 'Rediger tjenester',
      proposalSent: 'Tilbud sendt',
    },
    sidebar: {
      dashboard: 'Dashbord',
      pages: 'Sider',
      services: 'Tjenester',
      blog: 'Blogg',
      caseStudies: 'Case-studier',
      testimonials: 'Anbefalinger',
      leads: 'Leads',
      media: 'Media',
      settings: 'Innstillinger',
      profile: 'Profil',
    },
    layout: {
      adminPanel: 'Admin Panel',
      viewSite: 'Se nettsted',
      language: 'Språk',
      logout: 'Logg ut',
    },
    editor: {
      // Blog post editor
      title: 'Tittel',
      titleRequired: 'Tittel er påkrevd',
      slug: 'Slug',
      slugRequired: 'Slug er påkrevd',
      excerpt: 'Utdrag',
      excerptHint: 'Kort beskrivelse som vises i listevisning',
      category: 'Kategori',
      selectCategory: 'Velg kategori',
      coverImageUrl: 'Forsidebilde URL',
      content: 'Innhold',
      contentPlaceholder: 'Skriv innholdet her...',
      seoSettings: 'SEO-innstillinger',
      seoTitle: 'SEO-tittel',
      seoTitleHint: 'Overskriver standard tittel i søkeresultater',
      seoDescription: 'SEO-beskrivelse',
      seoDescriptionHint: 'Beskrivelse som vises i søkeresultater',
      keywords: 'Nøkkelord',
      keywordsHint: 'Kommaseparerte nøkkelord',
      status: 'Status',
      cancel: 'Avbryt',
      saveChanges: 'Lagre endringer',
      createPost: 'Opprett innlegg',
      createService: 'Opprett tjeneste',
      // Service editor
      basicInfo: 'Grunnleggende informasjon',
      shortDescription: 'Kort beskrivelse',
      icon: 'Ikon',
      order: 'Rekkefølge',
      featuredService: 'Fremhevet tjeneste',
      detailedDescription: 'Detaljert beskrivelse',
      detailedDescPlaceholder: 'Skriv en detaljert beskrivelse av tjenesten...',
      features: 'Funksjoner',
      benefits: 'Fordeler',
      faq: 'Ofte stilte spørsmål',
      addItem: 'Legg til',
      featureTitle: 'Tittel',
      featureDescription: 'Beskrivelse',
      question: 'Spørsmål',
      answer: 'Svar',
      callToAction: 'Call to Action',
      ctaText: 'CTA-tekst',
      ctaLink: 'CTA-lenke',
      heroImageUrl: 'Hero-bilde URL',
      // Categories
      categories: {
        crm: 'CRM',
        technology: 'Teknologi',
        marketing: 'Markedsføring',
        design: 'Design',
        tips: 'Tips',
      },
      // Rich text editor
      bold: 'Fet',
      italic: 'Kursiv',
      heading1: 'Overskrift 1',
      heading2: 'Overskrift 2',
      heading3: 'Overskrift 3',
      bulletList: 'Punktliste',
      numberedList: 'Nummerert liste',
      quote: 'Sitat',
      link: 'Lenke',
      image: 'Bilde',
      undo: 'Angre',
      redo: 'Gjør om',
      startWriting: 'Start skrivingen...',
      enterUrl: 'URL:',
      enterImageUrl: 'Bilde-URL:',
    },
    blog: {
      title: 'Blogg',
      subtitle: 'Administrer blogginnlegg',
      newPost: 'Nytt innlegg',
      editPost: 'Rediger innlegg',
      deletePost: 'Slett innlegg',
      status: 'Status',
      draft: 'Utkast',
      published: 'Publisert',
      noPosts: 'Ingen blogginnlegg',
      noPostsDesc: 'Du har ikke opprettet noen blogginnlegg ennå.',
      createFirst: 'Opprett ditt første innlegg',
    },
    services: {
      title: 'Tjenester',
      subtitle: 'Administrer tjenestene dine',
      newService: 'Ny tjeneste',
      editService: 'Rediger tjeneste',
      deleteService: 'Slett tjeneste',
      noServices: 'Ingen tjenester',
      noServicesDesc: 'Du har ikke opprettet noen tjenester ennå.',
      createFirst: 'Opprett din første tjeneste',
    },
    leads: {
      title: 'Leads',
      subtitle: 'Administrer henvendelser og leads',
      deleteLead: 'Slett lead',
      noLeads: 'Ingen leads funnet',
      noLeadsDesc: 'Du har ingen leads ennå',
      noLeadsFilter: 'Prøv et annet filter',
      email: 'E-post',
      phone: 'Telefon',
      company: 'Bedrift',
      companySize: 'Bedriftsstørrelse',
      interestedIn: 'Interessert i',
      message: 'Melding',
      status: {
        new: 'Ny',
        contacted: 'Kontaktet',
        qualified: 'Kvalifisert',
        proposal: 'Tilbud',
        won: 'Vunnet',
        lost: 'Tapt',
      },
    },
    caseStudies: {
      title: 'Case-studier',
      subtitle: 'Administrer case-studier og suksesshistorier',
      newCase: 'Ny case-studie',
      editCase: 'Rediger case-studie',
      deleteCase: 'Slett case-studie',
      noCases: 'Ingen case-studier',
      noCasesDesc: 'Du har ikke opprettet noen case-studier ennå.',
      createFirst: 'Opprett din første case-studie',
    },
    testimonials: {
      title: 'Kundeomtaler',
      subtitle: 'Administrer kundeomtaler og anbefalinger',
      newTestimonial: 'Ny testimonial',
      editTestimonial: 'Rediger testimonial',
      deleteTestimonial: 'Slett testimonial',
      noTestimonials: 'Ingen testimonials',
      noTestimonialsDesc: 'Du har ikke lagt til noen kundeomtaler ennå.',
      createFirst: 'Legg til din første testimonial',
      deleteConfirm: 'Er du sikker på at du vil slette denne omtalen fra {name}?',
    },
    media: {
      title: 'Media',
      subtitle: 'Administrer bilder og filer',
      upload: 'Last opp',
      deleteFile: 'Slett fil',
      noFiles: 'Ingen mediefiler',
      noFilesDesc: 'Du har ikke lastet opp noen filer ennå.',
      uploadFirst: 'Last opp din første fil',
    },
    pages: {
      title: 'Sider',
      subtitle: 'Administrer statiske sider',
      deletePage: 'Slett side',
      noPages: 'Ingen sider',
      noPagesDesc: 'Du har ikke opprettet noen sider ennå.',
    },
    settings: {
      title: 'Innstillinger',
      subtitle: 'Administrer globale nettstedsinnstillinger',
      general: 'Generelt',
      generalDesc: 'Grunnleggende nettstedsinformasjon',
      siteName: 'Sidenavn',
      siteNameRequired: 'Sitenavn er påkrevd',
      siteDescription: 'Sidebeskrivelse',
      logoUrl: 'Logo URL',
      logoDarkUrl: 'Logo URL (mørk modus)',
      contact: 'Kontaktinformasjon',
      contactDesc: 'Kontaktdetaljer som vises på nettsiden',
      email: 'E-post',
      emailInvalid: 'Ugyldig e-postadresse',
      phone: 'Telefon',
      address: 'Adresse',
      social: 'Sosiale medier',
      socialDesc: 'Lenker til sosiale medieprofiler',
      linkedin: 'LinkedIn',
      twitter: 'Twitter',
      facebook: 'Facebook',
      instagram: 'Instagram',
      footer: 'Footer',
      footerText: 'Footer-tekst',
      footerHint: 'Vises nederst på alle sider',
      saveSettings: 'Lagre innstillinger',
      saved: 'Lagret!',
    },
    profile: {
      title: 'Profil',
      subtitle: 'Administrer dine kontoinnstillinger',
      info: 'Profilinformasjon',
      infoDesc: 'Oppdater din kontoinformasjon',
      fullName: 'Fullt navn',
      email: 'E-post',
      emailHint: 'E-postadressen kan ikke endres',
      saveChanges: 'Lagre endringer',
      saved: 'Lagret!',
      role: 'Rolle',
      roleAdmin: 'Administrator',
      roleEditor: 'Redaktør',
      changePassword: 'Endre passord',
      changePasswordDesc: 'Oppdater ditt innloggingspassord',
      currentPassword: 'Nåværende passord',
      newPassword: 'Nytt passord',
      confirmPassword: 'Bekreft nytt passord',
      passwordChanged: 'Passord endret!',
      validation: {
        nameMin: 'Navn må være minst 2 tegn',
        emailInvalid: 'Ugyldig e-postadresse',
        passwordMin: 'Passord må være minst 6 tegn',
        passwordMatch: 'Passordene må være like',
      },
    },
  },

  // Auth
  auth: {
    login: {
      title: 'Logg inn',
      subtitle: 'Velkommen tilbake',
      email: 'E-post',
      password: 'Passord',
      submit: 'Logg inn',
      forgotPassword: 'Glemt passord?',
      error: 'Feil e-post eller passord',
    },
    logout: 'Logg ut',
  },

  // Footer
  footer: {
    services: 'Tjenester',
    company: 'Selskap',
    legal: 'Juridisk',
    privacy: 'Personvern',
    terms: 'Vilkår',
    copyright: '© 2026 Din AI Bedrift. Alle rettigheter reservert.',
    description: 'Vi hjelper norske bedrifter med digitale løsninger som driver vekst. CRM, apputvikling, webdesign, SMS-markedsføring og AI-stemmeassistenter.',
  },

  // Errors
  errors: {
    notFound: {
      title: 'Side ikke funnet',
      description: 'Beklager, vi fant ikke siden du leter etter. Den kan ha blitt flyttet eller slettet.',
      button: 'Til forsiden',
      goBack: 'Gå tilbake',
    },
    generic: 'Noe gikk galt',
  },

  // Legal pages
  legal: {
    privacy: {
      title: 'Personvernerklæring',
      seoDescription: 'Les vår personvernerklæring og hvordan vi behandler dine personopplysninger.',
      lastUpdated: 'Sist oppdatert: Januar 2024',
    },
    terms: {
      title: 'Vilkår og betingelser',
      seoDescription: 'Les våre vilkår og betingelser for bruk av tjenestene.',
      lastUpdated: 'Sist oppdatert: Januar 2024',
    },
  },
};
